module.exports = __webpack_public_path__ + "img/afther-3.d8d2dd2b.png";